import uiCore = require("../core/uicore");
import dataCore = require("../core/datacore");

export class InputDatePosInfDirective implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardComponentDescription = {
        DirectiveId: "crewinputdateposinf",
        Template: require("./crewinputdateposinf.html"),
        AngularDependencies: [],
        Bindings: {
            label: "@",
            crewdate: "=",

        },
        Link: (scope, _elem, attrs) => {
            if (attrs.hasOwnProperty('readonly')) {
                (<InputDatePosInfDirective>scope["vm"]).crewreadonly = true;
            }
            else {
                (<InputDatePosInfDirective>scope["vm"]).crewreadonly = false;
            }
        }
    }

    constructor(..._args: any[]) {
        this._dateNonInf = dataCore.getToday();
    }

    public label: string = "";
    private crewreadonly: boolean = false;
    public crewdate: Date;

    private _dateNonInf: Date;

    public onclicked() {
        if (this.crewreadonly) return;
        if (this.crewdate) {
            if (dataCore.isPosInfinity(this.crewdate)) {
                this.crewdate = this._dateNonInf;
            } else {
                this._dateNonInf = this.crewdate;
                this.crewdate = dataCore.DateMaxInfinity;
            }
        }
    }
} 


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/crewinputdateposinf.ts